import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import CourseReportDocument from '@/components/ReportPDF/CourseReportDocument'

import Spinner from '@/shared/Spinner'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { usePDF } from '@react-pdf/renderer'
import * as ReactDOMClient from 'react-dom/client'
import PDFViewerContainer from './PDFViewerContainer'

const mapStateToProps = ({ report }) => ({ data: report.sampleCourseData })

const FirstRenderDoc = ({ download, onDownload, ...props }) => {
  usePDF({
    document: <CourseReportDocument {...props} />,
  })

  return null
}

const loadFirstRenderDoc = ({ onRender, ...props }) => {
  const helperDiv = document.createElement('tmp')
  const newRoot = ReactDOMClient.createRoot(helperDiv)

  const doc = (
    <FirstRenderDoc
      {...props}
      onRender={onRenderProps => {
        onRender?.(onRenderProps)
        newRoot?.unmount()
        helperDiv?.remove()
      }}
    />
  )

  newRoot.render(<React.StrictMode>{doc}</React.StrictMode>)
}

const CourseReportSample = ({ dispatch, data }) => {
  const [pdfDoc, setPdfDoc] = useState()

  useEffect(() => {
    dispatch({ type: 'report/getSampleCourseData' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!pdfDoc && data) {
      loadFirstRenderDoc({
        reportData: { ...data, metaData: data },
        onRender: ({ pageData }) => {
          setPdfDoc(
            <CourseReportDocument pageData={pageData} reportData={{ ...data, metaData: data }} />,
          )
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdfDoc, data])

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* <WordPreview
        barChartImg={barChartImg}
        lineChartImg={lineChartImg}
        reportData={{
          ...data,
          phishType: t('general.mail'),
        }}
      /> */}

      {pdfDoc ? (
        <Container
          maxWidth={false}
          sx={{
            height: '100%',
            padding: 0,
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
          }}
        >
          <PDFViewerContainer document={pdfDoc} />
        </Container>
      ) : (
        <Stack sx={{ height: 200, width: 200 }}>
          <Spinner />
        </Stack>
      )}
    </div>
  )
}

export default connect(mapStateToProps)(CourseReportSample)
